import { Box, Grid } from '@material-ui/core';
import { KBLinks } from 'features/constants';
import { FC } from 'react';
import PageHeader from 'ui-kit/components/headers/PageHeader';
import { FincenResponse } from '../types';
import FilingInformation from './components/FilingInformation';

interface FilingInformationContentProps {
  onDataLoaded?: (data: FincenResponse) => void;
  onFormSubmitted?: () => void;
  submitted?: boolean;
}

const FilingInformationContent: FC<FilingInformationContentProps> = ({ onDataLoaded, onFormSubmitted, submitted }) => {
  return (
    <>
      <PageHeader
        title="Filing Information"
        subtitle={
          <>
            Complete the report in its entirety with all required information. Fields marked with an asterisk (
            <span style={{ color: '#a61712', fontWeight: 700 }}>*</span>) symbol are the fields that, at a minimum, must
            be completed by all companies to file the report. Reporting companies, however, must include all information
            31 CFR 1010.380(b) requires them to provide, regardless of whether a field is marked with an asterisk (
            <span style={{ color: '#a61712', fontWeight: 700 }}>*</span>) symbol.
          </>
        }
        menuItems={[
          {
            label: 'Knowledge Base',
            link: KBLinks.fincenReport,
          },
        ]}
        divider={true}
      />
      <Box mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FilingInformation onDataLoaded={onDataLoaded} onFormSubmitted={onFormSubmitted} submitted={submitted} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default FilingInformationContent;
